import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Switch,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useThemeContext } from "../context/ThemeContext";
import { useTranslation } from "react-i18next";

const ThemeConfigModal = ({ open, onClose }) => {
  const { mode, toggleDarkMode, primaryColor, setPrimaryColor } =
    useThemeContext();
  const { i18n } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Theme Config
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography sx={{ mb: 1 }}>Language</Typography>
        <ToggleButtonGroup
          value={i18n.language}
          exclusive
          onChange={(event, newLang) => newLang && i18n.changeLanguage(newLang)}
          fullWidth
        >
          <ToggleButton value="en">English</ToggleButton>
          <ToggleButton value="vi">Tiếng Việt</ToggleButton>
        </ToggleButtonGroup>
        {/* Dark Mode */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            my: 2,
          }}
        >
          <Typography>Dark Mode</Typography>
          <Switch checked={mode === "dark"} onChange={toggleDarkMode} />
        </Box>

        {/* Màu chủ đề */}
        <Typography sx={{ mb: 1 }}>Theme Color</Typography>
        <ToggleButtonGroup
          value={primaryColor}
          exclusive
          onChange={(event, newColor) => newColor && setPrimaryColor(newColor)}
          sx={{ mb: 2 }}
        >
          <ToggleButton
            value="#1976d2"
            style={{ backgroundColor: "#1976d2", color: "white" }}
          >
            Blue
          </ToggleButton>
          <ToggleButton
            value="#000000"
            style={{ backgroundColor: "#000000", color: "white" }}
          >
            Black
          </ToggleButton>
          <ToggleButton
            value="#388e3c"
            style={{ backgroundColor: "#388e3c", color: "white" }}
          >
            Green
          </ToggleButton>
          <ToggleButton
            value="#7b1fa2"
            style={{ backgroundColor: "#7b1fa2", color: "white" }}
          >
            Purple
          </ToggleButton>
          <ToggleButton
            value="#f57c00"
            style={{ backgroundColor: "#f57c00", color: "white" }}
          >
            Orange
          </ToggleButton>
          <ToggleButton
            value="#ffffff"
            style={{
              backgroundColor: "#ffffff",
              color: "black",
              border: "1px solid #ccc",
            }}
          >
            White
          </ToggleButton>
        </ToggleButtonGroup>
      </DialogContent>
    </Dialog>
  );
};

export default ThemeConfigModal;
